/**
 * Форматирование чисел для отображения баланса
 * Всегда показывает максимум 2 знака после запятой
 */

/**
 * Форматирует число баланса с максимально 2 знаками после запятой
 * @param {number|string} value - значение баланса
 * @returns {string} отформатированное значение
 */
export const formatBalance = (value) => {
    // Преобразуем в число если это строка
    const numValue = typeof value === 'string' ? parseFloat(value) : value;
    
    // Проверяем валидность
    if (numValue === null || numValue === undefined || typeof numValue !== 'number' || isNaN(numValue)) {
        return '0.00';
    }
    
    // Форматируем с двумя знаками после запятой
    return numValue.toFixed(2);
};

/**
 * Форматирует число баланса с локализацией
 * @param {number|string} value - значение баланса
 * @param {string} locale - локаль для форматирования (по умолчанию 'ru-RU')
 * @returns {string} отформатированное значение с локализацией
 */
export const formatBalanceLocale = (value, locale = 'ru-RU') => {
    const formattedValue = formatBalance(value);
    return Number(formattedValue).toLocaleString(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
};
